/**
 * Returns a throttled version of the argument function
 * that will run at most one time per timeFrame argument.
 */
export const throttle = (func: () => void, timeFrame: number): (() => void) => {
  let lastTime = 0;
  let timeoutId: NodeJS.Timeout | null = null;

  return function _throttle() {
    const now = Date.now();
    const timeElapsed = now - lastTime;

    if (timeElapsed >= timeFrame) {
      func();
      lastTime = now;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = null;
    } else if (!timeoutId) {
      // Make sure the function will run at least once
      // in the trailing edge
      timeoutId = setTimeout(_throttle, timeFrame - timeElapsed);
    }
  };
};
